import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarContasBancariasDs,
  criarReceitasDs,
  criarTipoAlvaraDiversoDs,
} from "../../DataSources";
import DataSource from "devextreme/data/data_source";
import uiInfo from "../../ui-info";
import { Button } from "devextreme-react";
import ShowError from "../../AppServices";

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  receitaId: undefined,
  titulo: undefined,
  templatePadrao: "",
  unidadeCobranca: "",
  valorUnitario: undefined,
  licenca: "",
  avisoAlvara: "",
  tipoMoeda: 0,
};

export default class TipoAlvaraDiversoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.tipoAlvaraDiversoDs = criarTipoAlvaraDiversoDs();
    this.receitasDs = [];

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    this.receitasDs = criarReceitasDs();

    this.receitaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      searchPlaceholder: "Procurar",
      cancelButtonText: "Cancelar",
      noDataText: "Nenhum registo encontrado",
      placeholder: "TODOS",
      dataSource: this.receitasDs,
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
    };

    this.moedaOpcoes = {
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "Real" },
        { id: 1, descricao: "Unidade Fiscal" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      console.log("params.id:", this.props.match.params.id);
      this.tipoAlvaraDiversoDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Registro não encontrado.", "error");
            this.props.history.push("/alvarasdiversos");
          }

          this.setState({
            id: data.id,
            sequencial: data.sequencial,
            prefeituraId: data.prefeituraId,
            receitaId: data.receitaId,
            titulo: data.titulo,
            templatePadrao: data.templatePadrao,
            unidadeCobranca: data.unidadeCobranca,
            valorUnitario: data.valorUnitario,
            licenca: data.licenca,
            avisoAlvara: data.avisoAlvara,
            tipoMoeda: data.tipoMoeda,
          });
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    criarReceitasDs()
      .load()
      .then((data) => {
        data.map((x) => {
          this.receitasDs.push(x);
        });
      });

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem
              caption="TIPO DE ALVARÁ DIVERSO"
              colSpan={2}
              colCount={2}
            >
              <SimpleItem dataField={"titulo"}>
                <Label text="Título" />
              </SimpleItem>
              <SimpleItem dataField={"templatePadrao"}>
                <Label text="Template" />
              </SimpleItem>
              <SimpleItem dataField={"unidadeCobranca"}>
                <Label text="Unidade de Cobrança" />
              </SimpleItem>
              <SimpleItem
                dataField={"valorUnitario"}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                cssClass={"txtNumerico"}
              >
                <Label text="Valor Unitário" />
              </SimpleItem>
              <SimpleItem
                dataField={"receitaId"}
                editorType={"dxLookup"}
                editorOptions={this.receitaOptions}
              >
                <Label text="Receita" />
              </SimpleItem>

              <SimpleItem
                dataField={"tipoMoeda"}
                editorType={"dxSelectBox"}
                editorOptions={this.moedaOpcoes}
              >
                <Label text="Moeda" />
              </SimpleItem>

              <SimpleItem dataField={"licenca"} colSpan={2}>
                <Label text="Licença" />
              </SimpleItem>

              <SimpleItem
                dataField={"avisoAlvara"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "100px" }}
                colSpan={2}
              >
                <Label text="Aviso do Alvará" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div style={{ marginTop: "10px" }}>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Cancelar" onClick={this.cancel} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = this.state;
    inserirOuAtualizar(this.tipoAlvaraDiversoDs, entidade)
      .then(
        function () {
          notify("Tipo de Alvará cadastrado com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
